import { render, staticRenderFns } from "./voiceDialog.vue?vue&type=template&id=ad1654f4&scoped=true"
import script from "./voiceDialog.vue?vue&type=script&lang=js"
export * from "./voiceDialog.vue?vue&type=script&lang=js"
import style0 from "./voiceDialog.vue?vue&type=style&index=0&id=ad1654f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1654f4",
  null
  
)

export default component.exports